function applyReviewsIONativeWidgetLayout(widgets = Array.from(document.querySelectorAll('[id^="ReviewsWidget-"], #ReviewsWidget'))) {
  widgets.forEach((widget) => {
    const rightGroup = widget.querySelector('.ElementsWidget__header .header__group--right');
    const section = widget.closest('.shopify-section');

    if (rightGroup) {
      rightGroup.style.setProperty('display', 'none', 'important');
    }

    if (section) {
      section.hidden = isEmptyReviewsWidget(widget);
    }
  });
}

function preserveReviewsIOPaginationScroll() {
  let restoreScrollIntoView = null;
  let restoreTimer = null;

  document.addEventListener('click', (event) => {
    if (!event.target?.closest?.('#ReviewsSummary .R-PaginationControls [role="button"]')) {
      return;
    }

    const reviewsWidget = document.querySelector('#ReviewsSummary [id^="ReviewsWidget-"], #ReviewsSummary #ReviewsWidget');

    if (!reviewsWidget) {
      return;
    }

    if (restoreScrollIntoView) {
      restoreScrollIntoView();
    }

    const nativeScrollIntoView = Element.prototype.scrollIntoView;

    Element.prototype.scrollIntoView = function scrollIntoReviewsWidget() {
      if (this.closest?.('.apps-section--reviews-summary-only')) {
        const rootScrollBehavior = document.documentElement.style.scrollBehavior;
        const bodyScrollBehavior = document.body.style.scrollBehavior;

        document.documentElement.style.scrollBehavior = 'auto';
        document.body.style.scrollBehavior = 'auto';
        nativeScrollIntoView.call(reviewsWidget, {
          block: 'start',
          inline: 'nearest',
          behavior: 'instant'
        });
        document.documentElement.style.scrollBehavior = rootScrollBehavior;
        document.body.style.scrollBehavior = bodyScrollBehavior;
        return;
      }

      return nativeScrollIntoView.apply(this, arguments);
    };

    restoreScrollIntoView = () => {
      Element.prototype.scrollIntoView = nativeScrollIntoView;
      restoreScrollIntoView = null;
      window.clearTimeout(restoreTimer);
      restoreTimer = null;
    };

    restoreTimer = window.setTimeout(restoreScrollIntoView, 1500);
  }, true);
}

function isEmptyReviewsWidget(widget) {
  const reviewItems = widget.querySelectorAll('.R-ContentList__item');

  if (reviewItems.length > 0) {
    return false;
  }

  const text = widget.textContent?.trim()?.toLowerCase() || '';

  return [
    'no reviews collected',
    'be the first to write a review',
    'keine bewertungen',
    'noch keine bewertungen',
    'sei der erste',
    'sois le premier',
    'soyez le premier',
    'scrivi la prima recensione',
    'sé el primero'
  ].some((emptyStateText) => text.includes(emptyStateText));
}

function observeReviewsIONativeWidgets() {
  let syncTimer = null;

  const queueSync = () => {
    if (syncTimer) {
      return;
    }

    syncTimer = window.setTimeout(() => {
      syncTimer = null;
      applyReviewsIONativeWidgetLayout();
    }, 100);
  };

  queueSync();

  if (!document.body) {
    return;
  }

  const observer = new MutationObserver(queueSync);

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class']
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    preserveReviewsIOPaginationScroll();
    observeReviewsIONativeWidgets();
  }, { once: true });
} else {
  preserveReviewsIOPaginationScroll();
  observeReviewsIONativeWidgets();
}
